(function () {
  const template = document.getElementById('collection-badge-templates');
  if (!template) return;

  // Build map: collection handle -> template <span> to clone
  const badgeTemplates = {};
  template.content.querySelectorAll('[data-badge-for]').forEach(span => {
    badgeTemplates[span.dataset.badgeFor] = span;
  });

  const handles = Object.keys(badgeTemplates);
  if (!handles.length) return;

  async function fetchAllHandles(collectionHandle) {
    const productHandles = new Set();
    let page = 1;
    while (true) {
      const url = `/collections/${collectionHandle}/products.json?limit=250&page=${page}&fields=handle`;
      const resp = await fetch(url);
      if (!resp.ok) break;
      const data = await resp.json();
      if (!data.products || !data.products.length) break;
      data.products.forEach(p => productHandles.add(p.handle));
      if (data.products.length < 250) break;
      page++;
    }
    return productHandles;
  }

  // Map: product handle -> array of collection handles it belongs to
  const productMap = {};

  Promise.all(
    handles.map(async handle => {
      const productHandles = await fetchAllHandles(handle);
      productHandles.forEach(ph => {
        if (!productMap[ph]) productMap[ph] = [];
        productMap[ph].push(handle);
      });
    })
  ).then(() => {
    document.querySelectorAll('[data-product-handle]').forEach(card => {
      const productHandle = card.dataset.productHandle;
      const collectionHandles = productMap[productHandle];
      if (!collectionHandles) return;

      const badgeContainer = card.querySelector('.card__badge');
      if (!badgeContainer) return;

      collectionHandles.forEach(collHandle => {
        const templateSpan = badgeTemplates[collHandle];
        if (!templateSpan) return;

        const upper = templateSpan.textContent.trim();
        const alreadyPresent = Array.from(badgeContainer.querySelectorAll('.badge'))
          .some(b => b.textContent.trim() === upper);
        if (alreadyPresent) return;

        const clone = templateSpan.cloneNode(true);
        clone.removeAttribute('data-badge-for');
        badgeContainer.appendChild(clone);
      });
    });
  });
})();
